/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useRef } from 'react';

import { DailyProvider, useCallFrame } from '@daily-co/daily-react';
import withAuth from 'hocs/withAuth/withAuth';
import { useSearchParams } from 'react-router-dom';

const Call = () => {
  const [searchParams] = useSearchParams();

  const callRef = useRef<HTMLElement>(null);
  const callFrame = useCallFrame({
    // @ts-ignore
    parentElRef: callRef,
    options: {
      iframeStyle: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        borderWidth: '0',
      },
    },
  });

  const url = searchParams.get('url') || '';

  if (url && callFrame) {
    callFrame.join({
      lang: 'user',
      url,
      showLeaveButton: true,
      showUserNameChangeUI: false,
    });
  }

  return (
    <DailyProvider callObject={callFrame}>
      <div ref={callRef as React.RefObject<HTMLDivElement>} />
    </DailyProvider>
  );
};

export default withAuth(Call);
